import type { FC } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { Header } from '@/components/header';
import { ThemeContextProvider } from '@/components/theme';
import { FacilitiesPage, MapPage, OrganizationsPage } from '@/pages';

const App: FC = () => {
  return (
    <ThemeContextProvider>
      <BrowserRouter>
        <div className="d-flex flex-column min-vh-100">
          <Header />
          <main className="flex-grow-1">
            <Routes>
              <Route path="/" element={<FacilitiesPage />} />
              <Route path="/organizations" element={<OrganizationsPage />} />
              <Route path="/map" element={<MapPage />} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
    </ThemeContextProvider>
  );
};

export default App;
